import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-modal',
  imports: [CommonModule, FormsModule],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.css'
})
export class ModalComponent {
  @Input() userData: any; 
  @Output() onSave = new EventEmitter<any>();
  @Output() onClose = new EventEmitter<void>();

  editedUser: any;

  ngOnInit() {
    this.editedUser = { ...this.userData }; 
  }

  saveChanges() {
    this.onSave.emit(this.editedUser);
  }

  closeModal() {
    this.onClose.emit();
  }
}
